module.exports = __webpack_public_path__ + "img/poulet_pois.b151174c.jpg";